import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.date.to-string.js";
import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: refactor this to use crystal-ui
import { Box, Chip, ExpandableStepLabel, IconTooltip, SrOnly, Stepper, Step, StepLabel, Tooltip, Typography, useId } from '@applyboard/ui-components';
import { CircleFillIcon, CircleOutlineIcon, ErrorOutlineIcon, InfoOutlineIcon, WarningOutlineIcon } from '@applyboard/ui-icons';
import { useEventTracker } from '@applyboard/ui-utils';
import { isAfter, differenceInDays, format } from 'date-fns';
import { StepStatus, useApplicationSteps } from "../../data/applicationSteps";
import { getApplicationStatusMessage } from '@applyboard/ab-application-legacy';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var LegacyApplicationStepper = function LegacyApplicationStepper(props) {
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var _useApplicationSteps = useApplicationSteps(),
    applicationSteps = _useApplicationSteps.applicationSteps,
    isLoadingApplicationSteps = _useApplicationSteps.isLoadingApplicationSteps,
    applicationStepsError = _useApplicationSteps.applicationStepsError;
  var deadlineTooltipId = useId();
  if (isLoadingApplicationSteps || applicationStepsError) {
    return _jsx(StepperContainer, {
      children: _jsx(EmptyState, {
        applicationSteps: applicationSteps,
        isLoadingApplicationSteps: isLoadingApplicationSteps,
        applicationStepsError: applicationStepsError
      })
    });
  }
  var steps = applicationSteps.length === 0 ? generateMockSteps() : applicationSteps;
  var activeStepIndex = getActiveStepIndex(steps);
  var chips = getUnhappyPathChips(props.application);
  var disabled = chips.length > 0 || applicationSteps.length === 0;
  return _jsxs("div", {
    children: [_jsx(StepperContainer, {
      disabled: disabled,
      children: _jsx(Stepper, {
        activeStep: activeStepIndex,
        labelPosition: "below",
        children: steps.map(function (step, idx) {
          var _props$application2, _props$application2$s;
          var showExpandableSection = step.status === StepStatus.InProgress && (typeof step.completedByApplicant === 'boolean' || typeof step.completedByApplyBoard === 'boolean');
          return _jsxs(Step, {
            completed: step.status === StepStatus.Complete,
            children: [!showExpandableSection ? _jsx(StepLabel, {
              children: _jsxs("span", {
                children: [_jsx(ScreenReaderStepDescription, {
                  step: step,
                  idx: idx
                }), step.displayName]
              })
            }) : _jsx(ExpandableStepLabel, {
              onExpand: function onExpand() {
                var _props$application, _props$application$me, _props$application$me2;
                trackEvent({
                  event: 'Single Application - Application Tracking System - Clicked on drop down',
                  data: {
                    application_status: getApplicationStatusMessage(props.application),
                    applicationStage: (_props$application = props.application) === null || _props$application === void 0 ? void 0 : (_props$application$me = _props$application.meta) === null || _props$application$me === void 0 ? void 0 : (_props$application$me2 = _props$application$me.current_stage) === null || _props$application$me2 === void 0 ? void 0 : _props$application$me2.name
                  }
                });
              },
              disabled: disabled,
              buttonLabel: _jsxs("span", {
                children: [_jsx(ScreenReaderStepDescription, {
                  step: step,
                  idx: idx
                }), step.displayName]
              }),
              expandableContent: _jsxs(Box, {
                pb: 1,
                pt: 1,
                style: {
                  borderTop: '1px solid #D7DAE8',
                  borderBottom: '1px solid #D7DAE8',
                  position: 'relative'
                },
                children: [_jsx(StepTask, {
                  completed: !!(step !== null && step !== void 0 && step.completedByApplicant),
                  displayName: "Completed By Applicant"
                }), _jsx(StepTask, {
                  completed: !!(step !== null && step !== void 0 && step.completedByApplyBoard),
                  displayName: "Completed By ApplyBoard"
                }), step.completedBySchool !== undefined && step.completedBySchool !== null && _jsx(StepTask, {
                  completed: step.completedBySchool,
                  informationText: (step === null || step === void 0 ? void 0 : step.completedBySchoolExplanation) || undefined,
                  displayName: "Completed By School"
                })]
              })
            }), ((_props$application2 = props.application) === null || _props$application2 === void 0 ? void 0 : (_props$application2$s = _props$application2.status) === null || _props$application2$s === void 0 ? void 0 : _props$application2$s.canceled) === false && step.deadlineStatus &&
            // This color is nowhere in the ui-components theme or color constants,
            // so hard-coding for now. (It is in crystal-ui, but I don't want to
            // introduce a dependency on crystal-ui because it is not mature yet) I think the
            // design team updated the colors but we didn't update ui-components.
            // See: https://applyboard.atlassian.net/browse/UIE-182
            // See: https://applyboard.slack.com/archives/C021LRQHB3M/p1648569852589129
            _jsx(Box, {
              mt: 1,
              display: "flex",
              justifyContent: "center",
              children: _jsx(Tooltip, {
                title: _jsx("span", {
                  id: deadlineTooltipId,
                  children: step.deadlineStatus === 'pending' ? 'We’re not able to calculate the deadline at the moment. Please check later.' : 'Submission deadlines are displayed in your local timezone'
                }),
                children: _jsx(Chip, {
                  color: "warning",
                  size: "small",
                  tabIndex: 0,
                  "aria-describedby": deadlineTooltipId,
                  children: _jsxs(Typography, {
                    style: {
                      fontSize: '14px',
                      color: '#612D10'
                    },
                    children: [_jsx("span", {
                      style: {
                        color: '#B35126'
                      },
                      children: "Deadline: "
                    }), step.deadlineStatus === 'pending' || !(step !== null && step !== void 0 && step.deadline) ? 'To Be Determined' : formatDeadline(step.deadline)]
                  })
                })
              })
            })]
          }, idx);
        })
      })
    }), chips.map(function (chip, chipKey) {
      return _jsx(Chip, {
        color: chip.color,
        label: chip.label,
        icon: chip.icon,
        mr: 1,
        mb: 2
      }, chipKey);
    })]
  });
};
function StepperContainer(props) {
  return _jsxs("div", {
    style: {
      position: 'relative',
      width: '100%'
    },
    children: [_jsx("section", {
      "aria-label": "Application Progress Stepper",
      style: {
        width: '100%',
        overflowX: 'auto'
      },
      children: props.children
    }), props.disabled && _jsx("div", {
      "data-testid": "stepper-disabled-cover",
      style: {
        // Needed to allow scrolling and highlighting text underneath.
        pointerEvents: 'none',
        backgroundColor: 'rgba(255,255,255,0.6)',
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0
      }
    })]
  });
}
function EmptyState(props) {
  var message = props.applicationStepsError ? 'An error occurred while trying to load application steps' : '';

  // To prevent layout shifting, we need to give a hard-coded height that
  // matches the height of the Stepper when it loads
  // See: https://web.dev/cls/
  return _jsx(Box, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    style: {
      height: 112,
      width: '100%'
    },
    children: _jsx(Typography, {
      children: message
    })
  });
}
function StepTask(props) {
  return _jsxs(Box, {
    display: "flex",
    alignItems: "center",
    children: [_jsx(Box, {
      display: "flex",
      alignItems: "center",
      flexGrow: 0,
      flexShrink: 0,
      marginRight: 1,
      children: props.completed ? _jsx(CircleFillIcon, {
        intent: "positive",
        size: "sm"
      }) : _jsx(CircleOutlineIcon, {
        intent: "secondary",
        size: "sm"
      })
    }), _jsxs(Typography, {
      style: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '14px',
        color: '#363b51'
      },
      children: [!props.completed && _jsx(SrOnly, {
        children: "Waiting to be"
      }), " ", props.displayName]
    }), props.informationText && _jsx(IconTooltip, {
      title: props.informationText,
      "aria-label": "More information",
      size: "small",
      ml: 0.25,
      icon: _jsx(InfoOutlineIcon, {})
    })]
  });
}
function ScreenReaderStepDescription(props) {
  var status = props.step.status === 'complete' ? 'Completed' : props.step.status === 'in_progress' ? 'In Progress' : 'Incomplete';
  return _jsx(SrOnly, {
    children: "Step ".concat(props.idx + 1, " ").concat(status, ". ")
  });
}
function getActiveStepIndex(applicationSteps) {
  var inProgressStep = applicationSteps.findIndex(function (step) {
    return step.status === StepStatus.InProgress;
  });
  if (inProgressStep !== -1) {
    return inProgressStep;
  }
  var allComplete = applicationSteps.every(function (step) {
    return step.status === StepStatus.Complete;
  });
  if (allComplete) {
    return applicationSteps.length - 1;
  }
  return -1;
}
function generateMockSteps() {
  return ['Pay Application Fee', 'Prepare Application', 'Submission In Progress', 'Decision', 'Post-Decision Requirements', 'Enrollment Confirmed'].map(function (displayName) {
    return {
      completedByApplicant: null,
      completedByApplyBoard: null,
      completedBySchool: null,
      completedBySchoolExplanation: null,
      displayName: displayName,
      status: StepStatus.Incomplete
    };
  });
}
function getUnhappyPathChips(application) {
  var statusObject = application === null || application === void 0 ? void 0 : application.status;
  var chips = [];
  if (statusObject !== null && statusObject !== void 0 && statusObject.withdrawn) {
    chips.push({
      label: 'Application Withdrawn',
      color: 'negative',
      icon: _jsx(ErrorOutlineIcon, {})
    });
  }
  if (statusObject !== null && statusObject !== void 0 && statusObject.canceled) {
    chips.push({
      label: 'Application Cancelled',
      color: 'negative',
      icon: _jsx(ErrorOutlineIcon, {})
    });
  }
  if (statusObject !== null && statusObject !== void 0 && statusObject.deferral_in_progress) {
    chips.push({
      label: 'Deferral Requested',
      color: 'info',
      icon: _jsx(InfoOutlineIcon, {})
    });
  }
  if (statusObject !== null && statusObject !== void 0 && statusObject.refund_in_progress) {
    chips.push({
      label: 'Refund Requested',
      color: 'info',
      icon: _jsx(InfoOutlineIcon, {})
    });
  }
  if (statusObject !== null && statusObject !== void 0 && statusObject.rejected) {
    chips.push({
      label: 'Application Rejected',
      color: 'negative',
      icon: _jsx(ErrorOutlineIcon, {})
    });
  }
  if (statusObject !== null && statusObject !== void 0 && statusObject.program_closed) {
    chips.push({
      label: 'Program Closed',
      color: 'negative',
      icon: _jsx(ErrorOutlineIcon, {})
    });
  }
  if (statusObject !== null && statusObject !== void 0 && statusObject.waitlisted) {
    chips.push({
      label: 'Application Waitlisted',
      color: 'warning',
      icon: _jsx(WarningOutlineIcon, {})
    });
  }
  return chips;
}
function formatDeadline(deadline) {
  var today = new Date();
  var deadlineDate = new Date(deadline);
  return isAfter(deadlineDate, today) && differenceInDays(deadlineDate, today) <= 3 ? format(deadlineDate, 'MMM dd, yyyy, hh:mma, O') : format(deadlineDate, 'MMM dd, yyyy');
}